module.exports = __webpack_public_path__ + "static/img/jindian@3x.94ebae2.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/jindian@3x.png
// module id = Z8YH
// module chunks = 52